<template>
    <div class="rhythmClass">
        <el-col :span="24" class="imgStyle" align="left">
            <div class="originalImage" :style="{width:(drawImgUrl? '48.5%':'98%')}" v-if="heart.questionDto.detailInfo.imgUrl">
                <p>题目图片</p>
                <img :src="heart.questionDto.detailInfo.imgUrl" v-viewer alt="原图片" title="原图片">
            </div>
            <div class="haveGotOnTheBus" v-if="drawImgUrl" :style="{width:(heart.questionDto.detailInfo.imgUrl? '':'98%')}">
                <p>答题图片</p>
                <img :src="drawImgUrl" alt="上传图片" title="上传图片">
            </div>
            <div class="footDer">
                <!-- <div class="playTheDrumsLeft" v-if="!drawImgUrl"></div> -->
                <div class="playTheDrumsRight">
                    <div class="operBox" @click="submitNumLimit()">
                        <updata-img ref="upImg"
                            :style="{pointerEvents:(!(submitNum>0||submitNum==-1)? 'none':'auto')}"
                            :styleEd="'\
                                width: 200px;\
                                font-size: 17px;\
                                background-color: rgb(0, 204, 106);\
                                color: #fff;border-radius: 5px;\
                                border: 3px solid rgb(207, 255, 232);'"
                                @upImgUrl="upImgUrl($event)"
                            :text="yangText">
                        </updata-img>
                        <p class="operation-num">剩余上传次数：{{submitNum==-1? '不限次':submitNum}}</p>
                        <div class="operation-tag">请在纸上绘画,并拍照上传 &nbsp;&nbsp;注：请上传jpge、png格式文件，文件大小限制在20MB内</div>
                    </div>
                </div>
            </div>
        </el-col>
    </div>
</template>
<script>
import audioStyle from '../../components/audioStyle'
import updataImg from '../../components/updataImg'
import utils from '../../lib/util'
import wsMethod from '../../lib/socketMethod'
    export default {
        name:"paintingHh",
        props: {
            sonData: Object,
            allAnswer:Object,
        },
        data() {
            return {
                heart:{
                    questionDto:{
                        detailInfo:{}
                    }
                },
                timeHer:'',
                advancedRadio:'',
                submitNum:0,
                questionImgUrl:'',
                drawImgUrl:'',
                yangText:'上传图片',
                score:'',//得分
                detailJsonVal:'',//得分细节 json
                answerType:null,
            }
        },
        components:{
            audioStyle,
            updataImg
        },
        watch: {
            'drawImgUrl':function(now,old){
                let that = this
                if(now&&that.answerType)that.answerType = null
                let pName = that.$route.query.paperName
                if((pName=="音乐测评"||pName=="中央美术学院中国画专业专业创作"||pName=="央美中国画专业专业创作")&&now){
                    that.getAjaxScore(now,()=>{
                        that.$emit('storeLocally')
                    })
                }else{
                    that.$emit('storeLocally')
                }
            },
            'submitNum':function(now,old){
                this.$emit('storeLocally')
            },
            'answerType':function(now,old){
                this.$emit('storeLocally')
            }
        },
        computed:{},
        created(){},
        mounted(){
            this.heart = this.sonData
            this.submitNum = utils.mottoClone(this.heart.submitNum)
            this.$nextTick(function(){
                if(this.allAnswer){
                    this.drawImgUrl = this.allAnswer.obj.drawImgUrl
                    this.answerType = this.allAnswer.obj.answerType
                    this.submitNum = this.allAnswer.submitNum
                    if(this.drawImgUrl){
                        this.yangText = ' 重  拍 '
                    }
                }
            })
        },
        methods:{
            upImgUrl(url){
                let plays = this.submitNum
                let nPlays = this.heart.submitNum
                if(plays>0||nPlays==-1){
                    this.drawImgUrl = url
                    this.$refs.upImg.url = ''
                    this.$refs.upImg.fileList = []
                    if(url){
                        this.yangText = ' 重  拍 '
                    }
                    if(this.submitNum<=0) this.submitNum==-1? this.submitNum=-1:this.submitNum=0
                    else this.submitNum--;

                    this.$nextTick(()=>{
                        wsMethod.wsSend210(this.heart.bId,this.heart.questionId,{
                            allData:this.$parent.allData,
                            uuid1:this.$parent.uuid1,
                            firstStartDateVal:this.$parent.firstStartDateVal,
                        })
                    })
                }else{
                    this.$message({showClose: true,message: `只能上传${nPlays}次`})
                }
            },
            yesNotProblem(){
                this.questionImgUrl = this.drawImgUrl
                if(this.drawImgUrl) return true
                return false
            },
            submitNumLimit(){
                let plays = this.submitNum
                let nPlays = this.heart.submitNum
                if(plays>0||nPlays==-1){}else{
                    this.$message({showClose: true,message: `只能上传${nPlays}次`})
                }
            },
            // 打分
            getAjaxScore(url,callback){
                let that = this
                that.$axios.post('/alg/img/similarity',{
                    firstUrl:that.heart.questionDto.detailInfo.imgUrl,
                    secondUrl:url,
                    uid:Number(that.$base64.decode(window.localStorage.getItem('uid-web'))),
                },res => {
                    var v = res.data
                    // console.log(res)
                    if (v.code == 0) {
                        that.score =utils.unsingNumber(((v.data.score/100)*that.heart.score),'floor',2)
                        that.detailJsonVal = JSON.stringify(v.data)
                    }
                    return callback()
                })
            },
            changeAnswerType(val){
                this.answerType = val.answerType
            }
        }
    }
</script>
<style scoped lang="less">
    .rhythmClass{
        height: 100%;
        width: 100%;
        position: relative;
        .zhiAudio{
            height: 33px;
            width: 100%;
            box-sizing: border-box;
            padding-left: 16px;
            .playNum{
                float: left;
                display: inline-block;
                height: 33px;
                width: 100px;
                .playNumIng{
                    display: inline-block;
                    img{
                        margin: 5px 0 0 15px;
                        vertical-align: text-bottom;
                    }
                }
            }
        }
        .explainText{
            box-sizing: border-box;
            padding:5px 0 0 16px;
            text-align: left;
            font-size: 12px;
            color: #A0A1A0;
        }
        .quImg{
            position: absolute;
            top: 0;
            left: 0;
            box-sizing: border-box;
            padding-top: 55px;
            width: 100%;
            height: 40%;
            display: inline-block;
            pointer-events: none;
            img{
                display: table-cell;
                vertical-align: middle;
                align-items: center;
                max-height: 100%;
                max-width: 70%;
            }
        }
        .imgStyle{
            position: absolute;
            top: 0%;
            left: 0;
            bottom: 0;
            width: 100%;
            box-sizing: border-box;
            padding: 25px 18px;
            background-image: url('../../../static/images/back-bg.png');
            background-repeat: no-repeat;
            background-size: 100% 100%;
            .originalImage{
                width: 48.5%;
                height: 80%;
                float: left;
                margin-left: 1%;
                p{
                    width: 100%;
                    text-align: center;
                    margin-top: 10px;
                }
                img{
                    width: 100%;
                    height: 93%;
                    object-fit: scale-down;
                }
            }
            .haveGotOnTheBus{
                width: 48.5%;
                height: 80%;
                float: right;
                margin-right: 1%;
                p{
                    width: 100%;
                    text-align: center;
                    margin-top: 10px;
                }
                img{
                    width: 100%;
                    height: 93%;
                    object-fit: scale-down;
                }
            }
            .footDer{
                position: absolute;
                bottom: 25px;
                height: 20%;
                width: 100%;
                float: left;
                .playTheDrumsLeft{
                    width: 38%;
                    height: 100%;
                    float: left;
                    position: relative;
                    background-image: url('../../../static/images/takingPictures.png');
                    background-size: 39%;
                    background-position: 95% 50%;
                    background-repeat: no-repeat;
                }
                .playTheDrumsRight{
                    width: 100%;
                    height: 100%;
                    float: left;
                    box-sizing: border-box;
                    position: relative;
                    display: table;
                    .operBox{
                        width: 100%;
                        display: table-cell;
                        vertical-align: middle;
                        .operationGo{
                            width: 100%;
                            font-size: 17px;
                            background-color: rgb(0, 204, 106);
                            color: #fff;
                            border-radius: 5px;
                            border: 3px solid rgb(207, 255, 232);
                        }
                        .operation-num{
                            font-size: 13px;
                            text-align: center;
                        }
                        .operation-tag{
                            // height: 20%;
                            width: 100%;
                            box-sizing: border-box;
                            padding: 1px 20px;
                            text-align: center;
                            color: #1D8EFE;
                            font-size: 0.8rem;
                        }
                    }
                }
            }
        }
        @media only screen and (max-height: 713px) {
            .imgStyle{
                padding: 30px 18px;
                .originalImage{
                    height: 75%;
                    margin-bottom: 2%;
                }
                .haveGotOnTheBus{
                    height: 75%;
                    margin-bottom: 2%;
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/exam/paintingHh.vue